import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { PlacedWebScreen } from '@/features/bill-payment/screens/union-pay/PlacedWeb.screen';
import { PlacedNativeScreen } from '@/features/bill-payment/screens/union-pay/PlacedNative.screen';

export interface PlacedScreenProps {}

export const PlacedScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.Placed>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const { onLayout, onBack, wallet, calcFee, beneficiaryInformation, refId, unionType, refresh, navigationNavigate, navigationScreen } =
    route.params;

  if (layout.isMobile) {
    return (
      <PlacedNativeScreen
        onBack={onBack}
        wallet={wallet}
        calcFee={calcFee}
        beneficiaryInformation={beneficiaryInformation}
        refId={refId}
        unionType={unionType}
        refresh={refresh}
        navigationNavigate={navigationNavigate}
        navigationScreen={navigationScreen}
      />
    );
  }
  return (
    <PlacedWebScreen
      onLayout={onLayout}
      onBack={onBack}
      wallet={wallet}
      calcFee={calcFee}
      beneficiaryInformation={beneficiaryInformation}
      refId={refId}
      unionType={unionType}
      refresh={refresh}
      navigationNavigate={navigationNavigate}
      navigationScreen={navigationScreen}
    />
  );
};
